import { FC } from 'react'
type ShoppingCartProps = {
  width?: number
  height?: number
  title?: string
  className?: string
}
const ShoppingCart: FC<ShoppingCartProps> = ({
  width = 18,
  height = 18,
  title,
  className,
}) => {
  return (
    <div className={className} title={title}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.125"
          y="5.625"
          width="15.75"
          height="10.5"
          stroke="currentColor"
          strokeWidth="0.75"
        />
        <path
          d="M13.5 6C13.5 3.51472 11.4853 1.5 9 1.5C6.51472 1.5 4.5 3.51472 4.5 6"
          stroke="currentColor"
          strokeWidth="0.75"
        />
      </svg>
    </div>
  )
}

export default ShoppingCart
